/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiChangeProfileCicRatingResponse {
    'total_cic_rating': number;
    'cic_rating_by_user': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "total_cic_rating",
            "baseName": "total_cic_rating",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "cic_rating_by_user",
            "baseName": "cic_rating_by_user",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiChangeProfileCicRatingResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

